<template>
  <video controls @click="videoClick(getVideoFromContent(content))" class="video-max video-play">
    <source :src="getVideoFromContent(content)">
  </video>
</template>

<script>
export default {
  name: 'message_video',
  props: [
    'content'
  ],
  methods: {
    getVideoFromContent (content) {
      const jsonContent = JSON.parse(content)
      return jsonContent.url
    },
    videoClick (url) {
      let routeData = this.$router.resolve({name: 'video', query: {videoSource: url}})
      window.open(routeData.href, '_blank', 'location=1,status=1,toolbar=1,scrollbars=1,resizeable=1,width=800,height=800')
    }
  }
}
</script>

<style scoped>
  .video-max {
    max-width: 250px;
  }
</style>



// WEBPACK FOOTER //
// src/components/webchat/message/fragments/message_video.vue